module.exports = __webpack_public_path__ + "static/closed-caption.39503da0.svg";